import { Injectable } from '@angular/core';
import { MonthlyCutBase } from "./monthly-cut-base";
import {
    InvestorMonthlyCut as T, Investor, Statement, Invoice
} from '../Interfaces';
export class InvestorMonthlyCut extends MonthlyCutBase implements T {
    id?: number;
    month?: number;
    year?: number;
    in_pool: number;
    pool_percentage: number;
    amount: number;
    adjustment?: number;
    constructor(json?: T,
        public investor?: Investor,
        public statement?: Statement,
        public invoice?: Invoice) {
        super(json);
    }
    hasStatement(): boolean {
        return Boolean(this.statement && this.statement.url);
    }
    hasInvoice(): boolean {
        return Boolean(this.invoice && this.invoice.xml_url);
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Classes/investor-monthly-cut.ts